// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2K99O","info":"Note_info__JrmzI","note":"Note_note__mSOdK","actions":"Note_actions__1XrJd"};